
import axios from 'axios'
import Router from 'vue-router'
import { Message,Notification  } from 'element-ui'
// create an axios instance
import router from '../router/index'
import Loading from '../components/Loading/index'
const instance = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 500000 // request timeout
})
let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
  /*loading = Loading.service({
    lock: true,
    text: '加载中。。。',
    background: 'rgba(0, 0, 0, 0.7)'
  })*/
   Loading.showLoading()

}
function endLoading() {    //使用Element loading-close 方法
  Loading.closeLoading();
}
const ok = 200

// request interceptor
instance.interceptors.request.use(
  config => {
    // startLoading();
    // Do something before request is sent
    /*  if (store.getters.token) {
      config.headers['Authorization'] = `Bearer ${getToken()}` // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    } */
    let token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    // console.log(token,'token');
    // //将问券id插到请求头中
    // let id = router.currentRoute.params.id;
    // if(id){
    //   config.headers.Authorization = id
    // }// config.headers.Cookies = 'SESSION=NTdjMGNmNDMtMDcxNy00YWE4LThhZjctZDZlNTFmNWI4Mzdj'

    return config
  },
  error => {
    // Do something with request error
    Message.error('对不起，出错了')
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone interceptor
instance.interceptors.response.use(
  response => {
     // endLoading();
    // debugger
    const res = response.data
    const errCode = res.code
    if (errCode !== undefined) {
      // debugger
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (errCode === 50008 || errCode === 50012 || errCode === 50014) {
        Message({
          message: '你已被登出，请重新登录',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error('token expired'))
      }else if(errCode === 500){
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(res)
      } else if (errCode !== ok) {
        Message({
          message: "请联系管理员",
          type: 'error',
          duration: 5 * 1000
        })
      }
      return res
    } else {
      return res
    }
  },
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  error => {
    // console.log(error,'response2222');
    const res = error.response;
    endLoading();
    if(res == undefined){
      // this.$message.info('登录过期，请重新登录');
      localStorage.removeItem('token');
      localStorage.removeItem("role");
      router.push({path:"/login"});
    }
    if(res){
      if(res.status === 511 || res.status === 401){
        Notification({
          message: res.data.message,
          type: 'error',
          duration: 5 * 1000
        })
        // window.parent.postMessage('登录过期','http://192.168.1.209:9527')
        // localStorage.removeItem('token');
        router.push({path:"/login"})
      }else if(res.status === 500 || res.status === 520 || res.status === 504){
        Message.error(res.data.message);
        // window.parent.postMessage('登录过期','http://192.168.1.209:9527')
        // localStorage.removeItem('token')
        // router.push({path:"/login"})
      }else if(res.status === 901){
        Message.error('已超过系统最大请求，请稍等。。。')
      }else{
        // window.parent.postMessage('登录过期','http://192.168.1.209:9527')
        // localStorage.removeItem('token')
        // router.push({path:"/login"})
      }
    }else{
      // window.parent.postMessage('登录过期','http://192.168.1.209:9527')
      // window.parent.postMessage('登录过期','https://saas.producttrying.com/')
      this.$message.error('登录过期，请重新登录');
      localStorage.removeItem('token');
      localStorage.removeItem("role");
      router.push({path:"/login"});
    }
    return Promise.reject(res)
  }
)

export const createAPI = (url, method, data, responseType) => {
  const config = {}

  if (method === 'get') {
    config.params = data
  } else {
    config.data = data
    if(responseType){
      config.responseType = responseType
    }
  }
  return instance({
    url,
    method,
    ...config
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js